import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { SeaaApp, createAppQueryClient } from './app'
import { getBrowserBootstrap } from './lib/app-runtime'
import { createAppRouter } from './router'
import { loadRouterForHydration } from './lib/router-hydration'
import { bootstrapStaffInvitationToken, startWebObservability } from './lib/observability'
import { createPublicTrafficTracker } from './lib/public-traffic'
import { subscribeAnalyticsConsent } from './lib/analytics-consent'
import './styles.css'
// SSR sends one entry stylesheet. Keep public route styling available before
// JavaScript loads even when those routes' interactive components are deferred.
import './features/marketing/legal-page.css'
import './features/marketing/examples-page.css'
import './features/marketing/business-link-page.css'
import './features/booking/booking-flow.css'

bootstrapStaffInvitationToken()
const root = document.getElementById('root')!
const bootstrap = getBrowserBootstrap()
// Apply the resolved locale before even the first client-rendered loading shell.
document.documentElement.lang = bootstrap.locale
document.documentElement.dir = bootstrap.locale === 'ar' ? 'rtl' : 'ltr'
void startWebObservability(bootstrap)
const queryClient = createAppQueryClient(bootstrap.dehydratedState)
const router = createAppRouter()
const trackPublicTraffic = createPublicTrafficTracker(bootstrap)
const trackPublicNavigation = () => { trackPublicTraffic(); void startWebObservability(bootstrap) }
router.subscribe('onResolved', trackPublicNavigation)
subscribeAnalyticsConsent(trackPublicTraffic)
document.addEventListener('visibilitychange', trackPublicNavigation)
const application = <StrictMode><SeaaApp router={router} bootstrap={bootstrap} queryClient={queryClient} /></StrictMode>

// Match server-rendered route chunks before hydrating their existing HTML.
if (root.hasChildNodes()) void loadRouterForHydration(router).then(() => hydrateRoot(root, application))
else createRoot(root).render(application)
